export function hasAddress(address: unknown): boolean {
  if (!address || typeof address !== 'object') {
    return false;
  }
  const addr = address as Record<string, unknown>;
  return !!(
    addr['id'] ||
    addr['address_1'] ||
    addr['flatHouseNo'] ||
    addr['address'] ||
    addr['pincode']
  );
}

export function formatAddress(address: unknown): string {
  if (!address) {
    return '';
  }
  if (typeof address === 'string') {
    return address.trim();
  }
  if (typeof address !== 'object') {
    return '';
  }
  const addr = address as Record<string, string | null | undefined>;
  const line1 = addr['address_1'] || addr['flatHouseNo'] || addr['address'];
  const landmark = addr['land_mark'] || addr['locality'];
  const parts = [
    line1,
    addr['address_2'],
    addr['address_3'],
    landmark,
    addr['city'],
    addr['state'],
    addr['pincode'],
  ]
    .map((part) => (typeof part === 'string' ? part.trim() : part))
    .filter((part) => part && part !== '');

  return parts.join(', ');
}

export interface BillingBlockOptions {
  isScrapOrStorePickup?: boolean;
  selectedBillingOption?: 'Billing' | 'gstin' | null;
}

export function shouldShowBillingBlock(
  userData: any,
  options: BillingBlockOptions = {},
): boolean {
  const hasBilling = hasAddress(userData?.billing_address);
  const hasShipping = hasAddress(userData?.shipping_address);

  if (options.isScrapOrStorePickup) {
    return hasBilling || hasShipping;
  }

  if (
    options.selectedBillingOption === 'Billing' ||
    options.selectedBillingOption === 'gstin'
  ) {
    return hasBilling || hasShipping;
  }

  if (!hasBilling) {
    return false;
  }

  return userData?.billing_address?.id !== userData?.shipping_address?.id;
}

export function shouldShowCartBillingSection(
  userData: any,
  storePickupOnly: boolean,
): boolean {
  const hasBilling = hasAddress(userData?.billing_address);
  const hasShipping = hasAddress(userData?.shipping_address);

  if (storePickupOnly) {
    return hasBilling || hasShipping;
  }

  if (!hasBilling) {
    return false;
  }

  return userData?.billing_address?.id !== userData?.shipping_address?.id;
}
